import { createContext } from 'react';
import { initServices } from '../services/servicesInitializator';

const services = initServices();
const ServiceContext = createContext(services);

export default ServiceContext;